import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'
import Typography, { FontWeights } from 'builder/styles/typography'
import { ButtonV2 } from 'builder/components/Button'
import Icon24 from 'builder/components/Icon'

export const UploadContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  padding: 16px;
  flex-shrink: 0;
  border-radius: var(--2XS, 8px);
  border: 1px solid ${Colors.Neutral15};
`

export const LabelUpload = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  width: 100%;
`

export const LabelWrapperUpload = styled.label`
  width: fit-content;
  position: relative;
`

export const UploadResumeName = styled.div`
  ${Typography.Body};
  color: ${Colors.Neutral90};
`

export const FileSize = styled.div`
  ${Typography.Body};
  color: ${Colors.Neutral50};
`

export const UploadButton = styled.label`
  display: flex;
  width: fit-content;
  min-width: 132px;
  height: 36px;
  padding: var(--2XS, 8px) var(--XS, 12px);
  position: relative;
  justify-content: center;
  cursor: pointer;
  align-items: center;
  flex-shrink: 0;
  border-radius: var(--3XS, 4px);
  border: 1px solid ${Colors.Neutral20};
  transition: border 0.2s ease-in-out, color 0.2s ease-in-out;
  background-color: ${Colors.White};
  color: ${Colors.Neutral90};
  ${Typography.Body};
  ${FontWeights.Medium};

  &:hover {
    transition: border 0.2s ease-in-out, color 0.2s ease-in-out;
    border: 1px solid ${Colors.Blue50};
    background-color: ${Colors.White};
    color: ${Colors.Blue50};
  }
`

export const ResumeSelectionContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 15px;
  flex-shrink: 0;
  border-radius: var(--2XS, 8px);
  border: 1px solid ${Colors.Neutral15};
  justify-content: space-between;

  ${Media.Phone`
    position: relative;
    height: 128px;
    margin-bottom: 0;
  `};
`

export const ResumeSelectionContainerV2 = styled.div`
  display: flex;
  width: 100%;
  padding: ${Spacing.XS} ${Spacing.M};
  flex-shrink: 0;
  border-radius: 8px;
  border: 1px solid ${Colors.Neutral10};
  background-color: ${Colors.White};
  justify-content: space-between;

  ${Media.Phone`
    flex-direction: column;
    gap: ${Spacing.S};
  `};
`

export const SelectLeft = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  flex-shrink: 0;
  position: relative;
  max-width: 244px;
`

export const SelectResumeTitle = styled.div`
  ${Typography.Caption};
  color: ${Colors.Neutral90};
  margin-bottom: 2px;
`

export const SelectResumeTitleV2 = styled.div`
  ${Typography.Caption};
  color: ${Colors.Neutral90};
  ${FontWeights.Medium};
`

export const SelectResumeDate = styled.div`
  ${Typography.Caption};
  color: ${Colors.Neutral50};
  margin-bottom: 18px;
`

export const SelectResumeInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${Spacing.XS};
  align-items: center;
`

export const SelectResumeDateV2 = styled.div`
  ${Typography.Caption};
  color: ${Colors.Neutral50};
`

export const StyledActionButton = styled(ButtonV2)`
  background-color: ${Colors.White};
  width: 100%;

  &:hover {
    background-color: ${Colors.White};
  }
`

export const ActionContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
`

export const SelectRight = styled.div`
  display: flex;
  text-align: center;
  position: relative;
  gap: 12px;
  overflow: hidden;
  flex-shrink: 0;

  ${Media.Phone`
      position: absolute;
      right: 16px;
  `};
`

export const DocumentPreviewContainer = styled.div`
  flex-shrink: 0;
  width: 104px;
  max-height: 104px;

  ${Media.Phone`
    width: 104px;
    height: 100px;
    margin-bottom: 0;
  `};
`

export const RightBottonShadow = styled.div`
  width: 200px;
  height: 25px;
  flex-shrink: 0;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 100%);
  position: absolute;
  top: 90px;
`

export const SpinnerRight = styled.div`
  display: flex;
  position: absolute;
  justify-content: end;
  align-items: center;
  gap: 1px;
  top: 10px;
  right: 10px;
`

export const SpinnerRightBar = styled.div`
  display: flex;
  position: absolute;
  justify-content: end;
  align-items: center;
  gap: 1px;
  top: 0;
  right: 0;
`

export const PreFillingText = styled.div`
  ${Typography.Caption};
  margin-left: 2px;
  color: ${Colors.Neutral90};
`

export const PreFilledText = styled.div`
  ${Typography.Caption};
  color: ${Colors.Green50};
  margin-left: 2px;
`

export const LabelSpinner = styled.div`
  position: relative;
  margin-right: 10px;
`

export const ResumePopupContainer = styled.div`
  position: absolute;
  top: -138px;
  right: 94px;
`

export const ResumeBuilderPopupContainer = styled.div`
  position: absolute;
  top: -68px;
  right: 190px;
`

export const ResumeBuilderPopupContainerV2 = styled.div`
  position: absolute;
  right: 490px;
`

export const DividerCircle = styled.div`
  width: 4px;
  height: 4px;
  border-radius: 4px;
  align-self: center;
  background-color: ${Colors.Neutral20};
`

export const EmailErrorContainer = styled.div`
  width: 90%;
`

export const ContactSupport = styled.a`
  ${Typography.Caption}
  ${FontWeights.Regular}

  color: ${Colors.Blue50};

  &:hover {
    border-bottom: 1px solid ${Colors.Blue50};
  }
`

export const TextWrapper = styled.div`
  display: flex;
  gap: ${Spacing.XS};

  ${Media.Tablet`
    flex-direction: column;
    gap: ${Spacing['4XS']};
  `};
`

export const RevertIcon = styled(Icon24.Revert)`
  color: ${Colors.Neutral40};
`

export const ViewIcon = styled(Icon24.View)`
  color: ${Colors.Neutral40};
`
